// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2KGVhPXvyKrzpy0rgs9IWm","icon":"_2oY7kqKH8mZSPsUNsDnqb0"};